import { BrowserRouter, Route, Routes } from 'react-router'
import { ModalGames } from '../components/games/modal-games'
import { ModalGameGoldMiner } from '../components/games/modal-game-gold-miner'
import { ProfileGames } from '../components/games/profile-games'
import { GiftReceivedPerUser } from '../components/gifts/gift-received-per-user'
import { GiftReturnLuck } from '../components/gifts/gift-return-luck'
import { GiftsAnimations } from '../components/gifts/gifts-animations'
import { ModalGifts } from '../components/gifts/modal-gifts'
import { Coins } from '../components/gifts/modal-gifts/coins'
import { Level } from '../components/gifts/modal-gifts/level'
import { ChatLive } from '../components/lives/chat-live'

// import { LiveVideo } from '../components/-not-use-live-video'
import { ModalGameBox } from '../components/games/modal-game-box'
import { GameBoxAnimation } from '../components/games/modal-game-box/components/animation'
import { GameBox } from '../components/games/modal-game-box/components/game-box'
import { LuckyBoxModal } from '../components/games/modal-game-box/modals/modal-lucky-box'
import { RocketGame } from '../components/games/rocket-game'
import { RocketGameEarning } from '../components/games/rocket-game/rocket-game-earning'
import { RocketGameModal } from '../components/games/rocket-game/rocket-game-modal'
import { QuantityGiftSent } from '../components/gifts/quantity-gift-sent'
import { ReturnValueLuck } from '../components/gifts/return-value-luck'
import { SendQuick } from '../components/lives/send-quick'
import { TrophyIcon } from '../components/lives/trophy-icon'
import { UserLevelUp } from '../components/lives/user-level-up'
import { UserLivePoints } from '../components/lives/user-live-points'

import { Tasks } from '../components/tasks'
import { ToastBubbleMessage } from '../components/toasts/toast-bubble-message'
import { ToastEarnedGlobal } from '../components/toasts/toast-earned-global'
import { ToastRocketGame } from '../components/toasts/toast-rocket-game'
import { ToastSendGlobal } from '../components/toasts/toast-send-global'
import { notifyCloseGame } from '../commom/rn-bridge'

function DirectGoldMinerRoute() {
  // X de fechar: o gold miner roda em iframe dentro do profile-games; avisamos
  // o host pra abrir o modal de confirmação de fechar (mesmo padrão dos slots).
  const handleCloseModal = () => {
    notifyCloseGame()
  }

  return <ModalGameGoldMiner handleCloseModal={handleCloseModal} />
}

export function Router() {
  return (
    <div className="w-screen h-screen bg-transparent font-[Nunito]">
      <BrowserRouter>
        <Routes>
          {/* deploy standalone: raiz abre o gold miner direto */}
          <Route path="/" element={<DirectGoldMinerRoute />} />
          {/* TOASTS */}
          {/* ${webview}/${type}?liveId=${liveId}&liveCountry=${liveCountry}&myUserId=${user?.id}&token=${token} */}
          <Route path="/gift-return-luck" element={<GiftReturnLuck />} />
          <Route path="/quantity-gift-sent" element={<QuantityGiftSent />} />
          <Route path="/return-value-luck" element={<ReturnValueLuck />} />
          <Route
            path="/toast-message-bubble"
            element={<ToastBubbleMessage />}
          />
          <Route path="/toast-earned-global" element={<ToastEarnedGlobal />} />
          <Route path="/toast-send-global" element={<ToastSendGlobal />} />
          <Route path="/user-level-up" element={<UserLevelUp />} />
          {/*  */}

          {/* ${webview}/chat-live?liveId=${liveId}&liveCountry=${liveCountry}&token=${token} */}
          <Route path="/chat-live" element={<ChatLive />} />

          {/* ${webview}/user-live-points?liveId=${liveId}&liveUserId=${userId}&token=${token} */}
          <Route path="/user-live-points" element={<UserLivePoints />} />

          {/* ${webview}/modal-gifts?liveId=${liveId}&liveUserId=${userId}&typeLive=${typeLive}&token=${token} */}
          <Route path="/modal-gifts" element={<ModalGifts />} />

          {/* ${webview}/game-box?liveId=${liveId}&token=${token} */}
          <Route path="/game-box" element={<GameBox />} />

          {/* ${webview}/game-box-animation?liveId=${liveId} */}
          <Route path="/game-box-animation" element={<GameBoxAnimation />} />

          {/* ${webview}/modal-game-box?liveId=${liveId}&isStreamer=${isStreamer}&token=${token} */}
          <Route path="/modal-game-box" element={<ModalGameBox />} />

          {/* ${webview}/modal-game-box-open?liveId=${liveId}&token=${token} */}
          <Route path="/modal-game-box-open" element={<LuckyBoxModal />} />

          {/* ${webview}/modal-games?token=${token} */}
          <Route path="/modal-games" element={<ModalGames />} />

          {/* ${webview}/gold-miner?token=${token} */}
          <Route path="/gold-miner" element={<DirectGoldMinerRoute />} />

          {/* ${webview}/profile-games?token=${token} */}
          <Route path="/profile-games" element={<ProfileGames />} />

          {/* Backward-compatible alias used by some app builds */}
          <Route path="/profile-modal" element={<ProfileGames />} />

          {/* ${webview}/coins?token=${token} */}
          <Route path="/coins" element={<Coins />} />

          {/* ${webview}/level?liveId=${liveId}&token=${token} */}
          <Route path="/level" element={<Level />} />

          {/* ${webview}/send-quick?token=${token} */}
          <Route path="/send-quick" element={<SendQuick />} />

          {/* LIVE */}
          {/* ${webview}/gift-received-per-user?liveId=${liveId}&position=${position} */}
          <Route
            path="/gift-received-per-user"
            element={<GiftReceivedPerUser />}
          />

          {/* ${webview}/gifts-animations?liveId=${liveId}` */}
          <Route path="/gifts-animations" element={<GiftsAnimations />} />

          {/* ROCKETS GAMES */}
          {/* ${webview}/rocket-game?liveId=${liveId}&liveUserId=${liveUserId}&token=${token} */}
          <Route path="/rocket-game" element={<RocketGame />} />

          {/* ${webview}/rocket-game-modal?liveUserId=${liveUserId}&token=${token} */}
          <Route path="/rocket-game-modal" element={<RocketGameModal />} />

          {/* ${webview}/rocket-game-earning?img=${img}&token=${token} */}
          <Route path="/rocket-game-earning" element={<RocketGameEarning />} />

          {/* ${webview}/toast-rocket-game?liveId=${liveId}&liveCountry=${liveCountry}&myUserId=${user?.id}&token=${token} */}
          <Route path="/toast-rocket-game" element={<ToastRocketGame />} />

          {/* LIVE_VIDEO */}
          {/* <Route path="/live-video" element={<LiveVideo />} /> */}

          {/* ${webview}/trophy-icon?liveId=${liveId}&liveUserId=${userId}&typeLive=${typeLive}&token=${token} */}
          <Route path="/trophy-icon" element={<TrophyIcon />} />

          {/* ${webview}/tasks?token=${token} */}
          <Route path="/tasks" element={<Tasks />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

// http://localhost:5173/modal-gifts?liveId=12&liveUserId=55000171&typeLive=multiAudio&token=<token>
